import { observable } from "mobx";
import { Type } from "class-transformer";
import PaginationResponse from "./paginationResponse";
import AccountBalanceCheckRequestsPermittedActionsResponse from "./accountBalanceCheckRequestsPermittedActionsResponse";
import AccountBalanceCheckRequestResponse from "./accountBalanceCheckRequestResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class AccountBalanceCheckRequestsResponse {
  @observable
  @Type(() => PaginationResponse)
  metadata!: PaginationResponse;

  @observable
  @Type(() => AccountBalanceCheckRequestsPermittedActionsResponse)
  permittedActions!: AccountBalanceCheckRequestsPermittedActionsResponse;

  /**
   * The list of account balance check requests.
   */
  @observable
  @Type(() => AccountBalanceCheckRequestResponse)
  items!: AccountBalanceCheckRequestResponse[];
}
